import {EventEmitter, Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';

@Injectable()
export abstract class BaseAPIService {

    public errorMessage = new EventEmitter <string> ();

    constructor(private http: HttpClient) {}

    protected get(url: string, options?: any): Observable<any> {
        return this.http
            .get(url, options);
    }

    protected post(url: string, data?: any, options?: any): Observable<any> {
        return this.http
            .post(url, data, options);
    }

    protected put(url: string, data?: any, options?: any): Observable<any> {
        return this.http
            .put(url, data, options);
    }

    protected delete(url: string, options?: any): Observable<any> {
        return this.http
            .delete(url, options);
    }

    protected handleError(error, operation?: string) {
        const errorMessage = operation || 'Something bad happened, please try again later.';
        if (error instanceof HttpErrorResponse) {
            console.log(`status: ${error.status}, ${error.statusText}`);
        } else {
            console.log(`${errorMessage}:`, error);
        }
        this.errorMessage.emit (errorMessage);
        return throwError(errorMessage);
    }
}
